<template>
  <v-col cols="12">
    <v-container fill-height>
      <v-row no-gutters align="center">
        <v-btn icon depressed color="primary" @click="back()">
          <v-icon> mdi-undo </v-icon>
        </v-btn>
        <span class="title">Content Pieces Maintenance</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="openPreview()">
          preview content
        </v-btn>
      </v-row>

      <v-row>
        <v-col style="text-align: center; text-justify: center" cols="3" xs="6" sm="6" md="3" lg="3" xl="3">
          <g-add-card ref="addCard" header="Add new Content Section" subHeader="click here to add a content section">
            <template v-slot:back-card="{flipBack}">
              <span class="title" style="color: white">Create New Content Section</span>
              <v-list-item dark  @click="controller.createContentSection(1)">
                <v-list-item-avatar>
                  <v-icon> mdi-pencil </v-icon>
                </v-list-item-avatar>
                <v-list-item-content> Add new text page </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item dark @click="controller.createContentSection(2)">
                <v-list-item-avatar>
                  <v-icon> mdi-image </v-icon>
                </v-list-item-avatar>
                <v-list-item-content> Add new image page </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item dark @click="controller.createContentSection(3)">
                <v-list-item-avatar>
                  <v-icon> mdi-file-video </v-icon>
                </v-list-item-avatar>
                <v-list-item-content> Add new video page </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-btn dense class="mb-0" small block rounded @click="flipBack()">cancel</v-btn>
            </template>
          </g-add-card>
        </v-col>
        <v-col cols="3" xs="6" sm="6" md="3" lg="3 " xl="3" v-for="(item, idx) in controller.list" :key="idx"
          style="text-align: center; text-justify: center">
          <g-list-card v-if="item.type == 1" :item="item" :header="item.description"
            :subHeader="contentTypes[item.type]" :editItem="controller.onEdit" :deleteItem="controller.delete"
            :editTt="editTt" :deleteTt="deleteTt" controller="content_section" />


          <contentMediaCard v-if="item.type == 2 || item.type == 3" mediaItemProp="mediaId" :item="item"
            :label="item.description" :onMediaItemChange="controller.updateSection" controller="content_section"
            :deleteItem="controller.delete" :deleteWholeItemTt="deleteWholeItemTt" :changeMediaTt="changeMediaTt"
            :deleteMediaTt="deleteMediaTt" :editTt="editTt" />
        </v-col>
      </v-row>
      <contentPreview ref="contentPreview" />
    </v-container>


  </v-col>
</template>
<script>
  import contentMediaCard from "../../../components/common/MediaCard/MediaCard";
  import contentPreview from "../maint/dialogs/preview-dialog";
  export default {
    components: {
      contentMediaCard,
      contentPreview
    },
    data() {
      return {
        controller: this.get_controller("content_section"),
        contentId: 0,
        contentItems: [],
        menu: false,
        type: 0,
        contentTypes: ["None", "Text", "Image", "Video"],
        deleteWholeItemTt: "Delete Content Section",
        deleteMediaTt: "Delete Media",
        editTt: "Edit Content Section",
        deleteTt: "Edit Content Section",
        changeMediaTt: "Change Media Content",
      };
    },
    mounted() {
      let self = this;
      self.contentId = self.$route.params.id;
      console.log(this.controller);
      this.controller.getAllSections();
    },
    methods: {
      openPreview() {
        let self = this
        self.$refs.contentPreview.show()
      },
      back() {
        this.$router.push("/Content");
      },
    },
  };
</script>